module.exports = __webpack_public_path__ + "static/RST-DSL-0,8m-2-e0f903682f0782873cb37f8758961b6c.jpg";